import React from "react";
import { Grid, Button } from "@material-ui/core";
import { useLocation, useNavigate } from "react-router-dom";
import NotFoundSvg from "../assets/notFoundSvg.svg";

const Unauthorized = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggin = Boolean(localStorage.getItem("authorization"));

  const handleBack = () => {
    if (isLoggin) {
      navigate("/dashboard");
    } else {
      // keep the original page so login can return to it
      navigate("/login", { state: location.state });
    }
  };

  return (
    <Grid item xs={12} container alignItems="center">
      <Grid item xs={6} style={{ paddingLeft: "2%" }}>
        <Grid item xs={12}>
          <p style={{ fontSize: "40px", fontWeight: 700, marginBottom: "1%" }}>
            Oops....
          </p>
        </Grid>
        <Grid item xs={12}>
          <p style={{ fontSize: "32px", fontWeight: 400, marginBottom: "1%" }}>
            {isLoggin ? "Access denied" : "Login required"}
          </p>
        </Grid>
        <Grid item xs={6}>
          <p style={{ fontSize: "16px", fontWeight: 400, marginBottom: "8%" }}>
            {isLoggin
              ? "Your account doesn't have permission to view this page."
              : "Please log in to view this page."}
          </p>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            style={{
              background: "#E81919",
              color: "white",
              textTransform: "none",
              paddingRight: "6%",
              paddingLeft: "6%",
            }}
            onClick={handleBack}
          >
            {isLoggin ? "Back to home" : "Login"}
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <img src={NotFoundSvg} alt="" />
      </Grid>
    </Grid>
  );
};

export default Unauthorized;
